
// Creates a unique string. Slightly formatted version of https://stackoverflow.com/questions/105034/create-guid-uuid-in-javascript
export function uuidv4(): string {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        // eslint-disable-next-line
        const r = Math.random() * 16 | 0;
        // eslint-disable-next-line
        const v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}
